import './CriteriaCheckbox.scss';

const CriteriaCheckbox = ({
  topText,
  bottomText,
  isSelected,
  onClick,
  className = ''
}) => {
  return (
    <div
      className={`criteria-checkbox ${
        isSelected ? 'selected' : 'unselected'
      } ${className}`}
    >
      <div className="criteria-checkbox-content">
        <div className="criteria-checkbox-text">
          <div className="criteria-checkbox-top-text">{topText}</div>
          <div className="criteria-checkbox-bottom-text">{bottomText}</div>
        </div>
        <div className="criteria-checkbox-check-container" onClick={onClick}>
          <svg
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="criteria-checkbox-check-icon"
          >
            <path
              d="M14 1.70909L12.5296 0L5.15269 8.5697L1.47043 4.29091L0 6L3.68226 10.2909L5.15269 12L6.63548 10.2909L14 1.70909Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default CriteriaCheckbox;
